/* ============================================
   JAB'S SEAFOOD — SHOPIFY THEME JS
   Converted from React/CartContext by Gulfline AI
   ============================================ */

(function() {
  'use strict';

  /* --- Sticky Navbar --- */
  const navbar = document.querySelector('.jabs-navbar');
  if (navbar) {
    const onScroll = () => {
      navbar.classList.toggle('scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Mobile Menu --- */
  const menuBtn = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('.jabs-mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open);
      const icon = menuBtn.querySelector('[data-icon]');
      if (icon) icon.setAttribute('data-icon', open ? 'close' : 'menu');
    });
    mobileMenu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        menuBtn.setAttribute('aria-expanded', false);
      });
    });
  }

  /* --- Cart Drawer --- */
  const cartDrawer  = document.querySelector('.jabs-cart-drawer');
  const cartOverlay = document.querySelector('.jabs-cart-overlay');
  const cartBody    = document.querySelector('.jabs-cart-drawer__body');
  const cartSubtotal = document.querySelector('.jabs-cart-drawer__subtotal-price');
  const cartBadges  = document.querySelectorAll('.jabs-cart-badge');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('is-open');
    cartOverlay && cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    cartOverlay && cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-open]').forEach(btn => {
    btn.addEventListener('click', openCart);
  });
  cartOverlay && cartOverlay.addEventListener('click', closeCart);
  document.querySelectorAll('[data-cart-close]').forEach(btn => {
    btn.addEventListener('click', closeCart);
  });

  function updateBadge(count) {
    cartBadges.forEach(badge => {
      badge.textContent = count > 0 ? (count > 9 ? '9+' : count) : '';
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchCart() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        updateBadge(cart.item_count);
        renderCart(cart);
      })
      .catch(console.error);
  }

  function renderCart(cart) {
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<p class="jabs-cart-drawer__empty">Your cart is empty</p>';
      if (cartSubtotal) cartSubtotal.textContent = '$0.00';
      return;
    }
    const items = cart.items.map(item => `
      <div class="jabs-cart-item" data-line-key="${item.key}">
        <div class="jabs-cart-item__img">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
        </div>
        <div class="jabs-cart-item__info">
          <div class="jabs-cart-item__name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="jabs-cart-item__price">${item.variant_title}</div>` : ''}
          <div class="jabs-cart-item__price">${formatMoney(item.line_price)}</div>
          <div class="jabs-cart-item__actions">
            <div class="jabs-cart-item__qty">
              <button class="jabs-cart-item__qty-btn" data-action="decrease" data-key="${item.key}">−</button>
              <span class="jabs-cart-item__qty-num">${item.quantity}</span>
              <button class="jabs-cart-item__qty-btn" data-action="increase" data-key="${item.key}">+</button>
            </div>
            <button class="jabs-cart-item__remove" data-key="${item.key}" aria-label="Remove">
              <svg fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
          </div>
        </div>
      </div>
    `).join('');
    cartBody.innerHTML = items;
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    bindCartItemEvents();
  }

  function bindCartItemEvents() {
    cartBody.querySelectorAll('[data-action]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const item = btn.closest('.jabs-cart-item');
        const qtyEl = item.querySelector('.jabs-cart-item__qty-num');
        let qty = parseInt(qtyEl.textContent, 10);
        qty = btn.dataset.action === 'increase' ? qty + 1 : qty - 1;
        if (qty < 0) qty = 0;
        updateCartItem(key, qty);
      });
    });
    cartBody.querySelectorAll('.jabs-cart-item__remove').forEach(btn => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }).then(r => r.json()).then(cart => {
      updateBadge(cart.item_count);
      renderCart(cart);
    }).catch(console.error);
  }

  /* --- Add to Cart --- */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    const variantId = btn.dataset.variantId || btn.closest('[data-variant-id]')?.dataset.variantId;
    if (!variantId) return;
    const qtyInput = document.querySelector('.jabs-qty-input');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    }).then(r => r.json()).then(() => {
      btn.textContent = 'Added!';
      fetchCart();
      setTimeout(() => openCart(), 300);
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = `<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/></svg> Add to Cart`;
      }, 1200);
    }).catch(err => {
      console.error(err);
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
    });
  });

  /* --- Quantity Controls (product page) --- */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.jabs-qty-btn');
    if (!btn) return;
    const input = btn.closest('.jabs-qty-ctrl').querySelector('.jabs-qty-input');
    if (!input) return;
    let val = parseInt(input.value, 10) || 1;
    if (btn.dataset.dir === 'up')   val = Math.min(val + 1, 99);
    if (btn.dataset.dir === 'down') val = Math.max(val - 1, 1);
    input.value = val;
  });

  /* --- Variant Selector (product page) --- */
  const variantBtns = document.querySelectorAll('.jabs-variant-option');
  const variantInput = document.querySelector('[name="id"]');
  const productPrice = document.querySelector('.jabs-product-price');

  if (variantBtns.length) {
    variantBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        variantBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        if (variantInput) variantInput.value = btn.dataset.variantId;
        if (productPrice && btn.dataset.price) {
          productPrice.textContent = btn.dataset.price;
        }
        const atcBtn = document.querySelector('[data-add-to-cart]');
        if (atcBtn) atcBtn.dataset.variantId = btn.dataset.variantId;
        const available = btn.dataset.available !== 'false';
        if (atcBtn) {
          atcBtn.disabled = !available;
          atcBtn.querySelector('[data-atc-text]') && (atcBtn.querySelector('[data-atc-text]').textContent = available ? 'Add to Cart' : 'Out of Stock');
        }
      });
    });
  }

  /* --- Collection Filter Tags --- */
  const filterTags = document.querySelectorAll('.jabs-filter-tag');
  filterTags.forEach(tag => {
    tag.addEventListener('click', () => {
      filterTags.forEach(t => t.classList.remove('active'));
      tag.classList.add('active');
      const filter = tag.dataset.filter;
      document.querySelectorAll('.jabs-product-card').forEach(card => {
        if (!filter || filter === 'all') { card.closest('[data-product-item]').style.display = ''; return; }
        const type = card.dataset.productType || '';
        card.closest('[data-product-item]').style.display = type.toLowerCase().includes(filter) ? '' : 'none';
      });
    });
  });

  /* --- Initial cart count --- */
  fetchCart();
  /* --- Collection Sort --- */
  const sortSelect = document.querySelector('.jabs-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const val = sortSelect.value;
      const grid = document.querySelector('.jabs-product-grid');
      if (!grid) return;
      const cards = Array.from(grid.querySelectorAll('.jabs-product-card[data-product-item]'));
      cards.sort((a, b) => {
        if (val === 'price-asc' || val === 'price-desc') {
          const priceA = parseFloat(a.dataset.productPrice || 0);
          const priceB = parseFloat(b.dataset.productPrice || 0);
          return val === 'price-asc' ? priceA - priceB : priceB - priceA;
        }
        if (val === 'title-asc') {
          const titleA = (a.dataset.productTitle || '').toLowerCase();
          const titleB = (b.dataset.productTitle || '').toLowerCase();
          return titleA.localeCompare(titleB);
        }
        return 0;
      });
      cards.forEach(card => grid.appendChild(card));
    });
  }

})();


